import { FC } from "react";

const SVG: FC<{ select: string }> = ({ select }) => {
  if (select) {
    if (select === "null") return null;
    if (select === "cookie")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="49.999" height="50.01" viewBox="0 0 49.999 50.01">
          <path
            className="aCookies"
            d="M501.8,105.038c-.287-.155-.565-.326-.841-.5-.067-.043-.138-.078-.2-.122-.157-.105-.3-.223-.45-.334s-.327-.233-.482-.357-.311-.262-.463-.4h0a13.243,13.243,0,0,1-2.285-17.288.053.053,0,0,0,.008-.053.055.055,0,0,0-.046-.034,23.714,23.714,0,0,0-7.158-.31,23.259,23.259,0,0,0-12.948,5.726.726.726,0,0,1-.85.074q-.6.785-1.124,1.611a.724.724,0,0,1-.173.471c-.182.207-.338.428-.512.639a23.495,23.495,0,0,0,33.079,33.063c.209-.172.428-.323.632-.5h0a.715.715,0,0,1,.459-.172q.829-.531,1.616-1.129a.726.726,0,0,1,.076-.847,23.457,23.457,0,0,0,5.548-11.727.074.074,0,0,0-.082-.031,8.378,8.378,0,0,1-9.074-5.13c-.1-.239-.216-.471-.3-.722a.811.811,0,0,0-.608-.563,13.215,13.215,0,0,1-2.751-.854c-.023-.009-.044-.021-.066-.031-.158-.07-.315-.145-.471-.22C502.156,105.213,501.976,105.132,501.8,105.038Zm-1.279,15.577Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path
            className="bCookies"
            d="M474.558,124.628a23.5,23.5,0,0,0,32.567,2.612,24.259,24.259,0,0,1-33.079-33.062A23.506,23.506,0,0,0,474.558,124.628Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path
            className="aCookies"
            d="M474.508,92.51c.092-.1.171-.205.265-.3-.093.1-.187.192-.279.291l.008,0Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path
            className="aCookies"
            d="M514.945,95.8a.834.834,0,1,0-.834-.834A.834.834,0,0,0,514.945,95.8Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path
            d="M514.945,92.663a2.3,2.3,0,1,0,2.3,2.3A2.3,2.3,0,0,0,514.945,92.663Zm0,3.134a.834.834,0,1,1,.833-.834A.834.834,0,0,1,514.945,95.8Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path className="cCookies" d="M474.773,92.207l.036-.037Z" transform="translate(-467.244 -84.051)"></path>
          <path
            className="bCookies"
            d="M504.062,90.763l.133-.8-.021.006a1.628,1.628,0,0,0-1.13,1.283l-.225,1.348a1.619,1.619,0,0,0,1.027,1.779l1.989.746c.058.021.117.04.176.055a1.612,1.612,0,0,0,1.636-.545l-1.721-.642A2.932,2.932,0,0,1,504.062,90.763Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path
            className="bCookies"
            d="M509.236,101.864l.76,1.775a.848.848,0,0,0,.232.311.834.834,0,0,0,1.174-.106l.172-.206a1.73,1.73,0,0,1-.58-.72l-.863-2.007a1.788,1.788,0,0,1-.078-.331l-.424.211A.834.834,0,0,0,509.236,101.864Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path
            className="dCookies"
            d="M505.679,116.436a.732.732,0,0,0,1.385-.335.745.745,0,0,0-.075-.321l-.783-1.565a.732.732,0,1,0-1.31.655Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path
            className="dCookies"
            d="M475.172,107.189a.733.733,0,1,0-1.31.656l.783,1.565a.732.732,0,1,0,1.31-.655Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path
            className="bCookies"
            d="M483.289,121.445l-1.565.783a.732.732,0,1,0,.655,1.31l1.565-.783a.732.732,0,1,0-.655-1.31Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path
            className="dCookies"
            d="M487.032,94.671l-1.566.782a.732.732,0,1,0,.655,1.31l1.566-.782a.732.732,0,0,0-.655-1.31Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path
            className="bCookies"
            d="M489.589,91.273a.733.733,0,0,0,1.037-1.037l-.783-.782a.733.733,0,0,0-1.036,1.036Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path
            className="dCookies"
            d="M494.638,124.989a.733.733,0,0,0-.733.733v.783a.732.732,0,0,0,1.465,0v-.783A.733.733,0,0,0,494.638,124.989Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path
            className="eCookies"
            d="M492.71,119.081l.783-.782a.733.733,0,0,0-1.037-1.037l-.783.783a.733.733,0,0,0,1.037,1.036Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path
            className="bCookies"
            d="M506.2,120.982l-.783.783a.733.733,0,0,0,1.036,1.037l.783-.783a.733.733,0,0,0-1.036-1.037Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path
            className="fCookies"
            d="M478.3,98.9l.782-.782a.733.733,0,0,0-1.036-1.037l-.783.783A.733.733,0,0,0,478.3,98.9Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path
            className="gCookies"
            d="M506.724,95.927a2.181,2.181,0,0,1-.353.024A2.181,2.181,0,0,0,506.724,95.927Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path
            className="gCookies"
            d="M503.588,95.065l1.989.745a2.3,2.3,0,0,0,.742.138,2.292,2.292,0,0,1-.742-.143l-1.989-.746a2.348,2.348,0,0,1-1.523-2.17A2.349,2.349,0,0,0,503.588,95.065Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path className="gCookies" d="M506.762,95.922l-.038.005Z" transform="translate(-467.244 -84.051)"></path>
          <path
            className="gCookies"
            d="M502.321,91.131a2.35,2.35,0,0,1,1.638-1.866l.085-.026-.081.024a2.349,2.349,0,0,0-1.642,1.863l-.225,1.348a2.332,2.332,0,0,0-.031.415,2.266,2.266,0,0,1,.031-.409Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path
            className="gCookies"
            d="M506.371,95.951c-.018,0-.035,0-.052,0C506.336,95.949,506.353,95.951,506.371,95.951Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path
            d="M507.856,87.787a3.078,3.078,0,0,0-1.63.038l-2.473.739a3.1,3.1,0,0,0-2.154,2.445l-.225,1.348a3.087,3.087,0,0,0,1.957,3.393l1.989.746a3.079,3.079,0,0,0,4.072-2.138l.709-2.836A3.08,3.08,0,0,0,507.856,87.787Zm-2.279,8.023-1.989-.745a2.352,2.352,0,0,1-1.524-2.176,2.432,2.432,0,0,1,.032-.415l.225-1.348a2.349,2.349,0,0,1,1.642-1.863l.081-.024-.085.026a2.35,2.35,0,0,0-1.638,1.866L502.1,92.48a2.339,2.339,0,0,0,1.492,2.579l1.989.746a2.292,2.292,0,0,0,.742.143A2.3,2.3,0,0,1,505.577,95.81Zm1.7-.038h0a2.4,2.4,0,0,0,.221-.11h0A2.259,2.259,0,0,1,507.278,95.772Zm.491-.279a2.36,2.36,0,0,0,.216-.172h0A2.36,2.36,0,0,1,507.769,95.493Zm.33-.29h0a2.407,2.407,0,0,0,.251-.306A2.407,2.407,0,0,1,508.1,95.2Zm.581-4.037L507.971,94a1.633,1.633,0,0,1-1.96,1.177c-.059-.015-.118-.034-.176-.055l-1.989-.746a1.619,1.619,0,0,1-1.027-1.779l.225-1.348a1.628,1.628,0,0,1,1.13-1.283l.021-.006,2.452-.733a1.652,1.652,0,0,1,.473-.07,1.619,1.619,0,0,1,1.607,1.632A1.638,1.638,0,0,1,508.68,91.166Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path
            d="M513.457,100.077c-.03-.025-.061-.049-.092-.072l-1.038-.78a2.287,2.287,0,0,0-2.408-.217l-.945.472a2.3,2.3,0,0,0-1.085,2.958l.76,1.774a2.286,2.286,0,0,0,1.781,1.374,2.394,2.394,0,0,0,.339.024,2.284,2.284,0,0,0,1.759-.827l1.224-1.469A2.3,2.3,0,0,0,513.457,100.077Zm-4.221,1.787a.834.834,0,0,1,.393-1.073l.424-.211.526-.262h-.005a.831.831,0,0,1,.873.078l1.038.78a.833.833,0,0,1,.167,1.167l-.026.033-1.052,1.263-.172.206a.834.834,0,0,1-1.174.106.848.848,0,0,1-.232-.311Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path
            className="gCookies"
            d="M479.131,129.489q-.982-.632-1.913-1.364Q478.137,128.851,479.131,129.489Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path
            className="gCookies"
            d="M470.637,97.99q.516-1.009,1.131-1.974Q471.159,96.972,470.637,97.99Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path
            className="gCookies"
            d="M477.186,128.1a24.079,24.079,0,0,1-1.817-1.593A24,24,0,0,0,477.186,128.1Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path
            className="gCookies"
            d="M481.184,130.669q-1.023-.523-2-1.147Q480.149,130.14,481.184,130.669Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path
            className="gCookies"
            d="M483.319,131.631q-1.053-.414-2.069-.929Q482.255,131.212,483.319,131.631Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path
            className="gCookies"
            d="M470.9,120.637a24.441,24.441,0,0,0,4.462,5.869,24.569,24.569,0,0,1-4.462-5.869Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path
            className="gCookies"
            d="M474.571,93.538a.721.721,0,0,0,.172-.471c-.234.367-.471.733-.685,1.111C474.232,93.966,474.388,93.745,474.571,93.538Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path className="gCookies" d="M505.924,129.1l-.051.037Z" transform="translate(-467.244 -84.051)"></path>
          <path className="gCookies" d="M483.415,131.669l-.1-.038Z" transform="translate(-467.244 -84.051)"></path>
          <path className="gCookies" d="M470.591,98.081l.046-.091Z" transform="translate(-467.244 -84.051)"></path>
          <path className="gCookies" d="M471.768,96.016l.053-.082Z" transform="translate(-467.244 -84.051)"></path>
          <path className="gCookies" d="M481.25,130.7l-.066-.033Z" transform="translate(-467.244 -84.051)"></path>
          <path className="gCookies" d="M477.218,128.125l-.032-.025Z" transform="translate(-467.244 -84.051)"></path>
          <path className="gCookies" d="M479.182,129.522l-.051-.033Z" transform="translate(-467.244 -84.051)"></path>
          <path className="gCookies" d="M475.369,126.507h0Z" transform="translate(-467.244 -84.051)"></path>
          <path className="gCookies" d="M470.9,120.637l-.005-.01Z" transform="translate(-467.244 -84.051)"></path>
          <path
            className="dCookies"
            d="M508.8,126.8l0,0c-.005-.005-.012-.007-.017-.013a.754.754,0,0,0-1.015-.051h0c-.2.18-.423.331-.632.5a23.494,23.494,0,0,1-33.079-33.062c.214-.378.451-.744.685-1.111a.722.722,0,0,0-.235-.557L474.5,92.5l-.008,0a.732.732,0,0,0-1.027.072,24.989,24.989,0,0,0,35.267,35.268A.733.733,0,0,0,508.8,126.8Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path className="gCookies" d="M500.307,120.628h0Z" transform="translate(-467.244 -84.051)"></path>
          <path
            className="aCookies"
            d="M508.676,91.154a1.579,1.579,0,0,0,.047-.375,1.619,1.619,0,0,0-1.607-1.632,1.639,1.639,0,0,0-.472.07l-2.452.733-.134.8a2.935,2.935,0,0,0,1.864,3.229l1.721.642a1.584,1.584,0,0,0,.324-.632Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <path
            className="aCookies"
            d="M510.994,102.9a1.73,1.73,0,0,0,.58.72l1.052-1.263.026-.033a.833.833,0,0,0-.167-1.167l-1.038-.779a.829.829,0,0,0-.873-.079h.005l-.526.262a1.715,1.715,0,0,0,.079.331Z"
            transform="translate(-467.244 -84.051)"
          ></path>
          <g transform="translate(-467.244 -84.051)">
            <path
              className="hCookies"
              d="M497.217,107.9c-.011-.176-.024-.349-.04-.513-.011-.109-.024-.218-.038-.318-.018-.133-.037-.267-.059-.4-.019-.109-.035-.2-.059-.318s-.05-.222-.077-.329-.056-.216-.083-.307-.055-.163-.091-.263-.071-.205-.112-.3c-.007-.017-.015-.032-.023-.048a4.038,4.038,0,0,0-.4-.711c-.025-.036-.048-.074-.074-.109-.072-.093-.149-.179-.229-.264-.034-.031-.066-.067-.1-.1a3.435,3.435,0,0,0-.264-.233c-.032-.027-.065-.054-.1-.079-.1-.075-.2-.146-.312-.211-.024-.015-.051-.029-.076-.043a6.619,6.619,0,0,0-2.573-.727,19.065,19.065,0,0,0-2.041-.1h-1.278c-1.183,0-1.557.374-1.557,1.558v15.421a3.69,3.69,0,0,1,.018-.42,3.9,3.9,0,0,1,4.262-3.5l.273-.007c3.253-.056,5.071-2.022,5.071-6.516,0-.307-.008-.6-.02-.876C497.231,108.088,497.223,108,497.217,107.9Z"
            ></path>
            <path
              className="dCookies"
              d="M496.318,91.188a11.776,11.776,0,0,1,1.768-4.322,1.517,1.517,0,0,0-.976-2.337,25.185,25.185,0,0,0-7.607-.33,24.725,24.725,0,0,0-13.755,6.084.734.734,0,0,0-.066,1.032v0c.007.007.016.01.023.017a.754.754,0,0,0,1.011.048,23.259,23.259,0,0,1,12.948-5.726,23.715,23.715,0,0,1,7.158.311.056.056,0,0,1,.046.033.053.053,0,0,1-.007.053A13.179,13.179,0,0,0,495.6,98.244a10.886,10.886,0,0,1,1.731.312A11.673,11.673,0,0,1,496.318,91.188Z"
            ></path>
            <path
              className="dCookies"
              d="M516.505,111.829a1.561,1.561,0,0,0-1.33-.447,6.946,6.946,0,0,1-1.008.074,7.072,7.072,0,0,1-6.754-4.924,2.276,2.276,0,0,0-1.729-1.555,11.84,11.84,0,0,1-2.376-.722c-.183-.077-.358-.167-.536-.253l-.086-.042c-.091-.043-.179-.089-.268-.133a14.249,14.249,0,0,1,.359,1.782,13.167,13.167,0,0,0,2.628.808.809.809,0,0,1,.608.563c.081.252.2.483.3.722a8.344,8.344,0,0,0,7.852,5.22,8.6,8.6,0,0,0,1.221-.09.073.073,0,0,1,.082.032,23.454,23.454,0,0,1-5.548,11.726.726.726,0,0,0-.076.847h0a.693.693,0,0,0,.126.166c.007.006.009.014.015.019l0,0a.732.732,0,0,0,1.034-.066,24.921,24.921,0,0,0,5.894-12.456A1.464,1.464,0,0,0,516.505,111.829Z"
            ></path>
            <path
              className="dCookies"
              d="M502.588,105.533q-.237-.106-.471-.221c-.177-.086-.357-.166-.531-.26-.287-.156-.565-.327-.841-.5-.067-.043-.138-.078-.2-.122-.157-.1-.3-.223-.45-.333s-.326-.234-.482-.358-.311-.262-.463-.4c-.018-.015-.033-.032-.05-.047a13.2,13.2,0,0,1-3.306-4.531c-.075-.169-.125-.347-.192-.519a14.834,14.834,0,0,0-1.521-.081h-8.755c-2.025,0-3.3,1.028-3.3,3.365v15.111c0,2.337,1.278,3.334,3.3,3.334h9.036c7.01,0,8.631-4.517,8.631-10.9v0a25.3,25.3,0,0,0-.211-3.459c-.041-.017-.083-.028-.123-.046C502.632,105.554,502.61,105.543,502.588,105.533Zm-10.4,10.046-.273.007a3.9,3.9,0,0,0-4.262,3.5,3.69,3.69,0,0,0-.018.42V104.086c0-1.184.374-1.558,1.557-1.558h1.278a19.065,19.065,0,0,1,2.041.1,6.619,6.619,0,0,1,2.573.727c.025.014.052.028.076.043.107.065.211.136.312.211.035.025.068.052.1.079a3.435,3.435,0,0,1,.264.233c.034.033.066.069.1.1.08.085.157.171.229.264.026.035.049.073.074.109a4.038,4.038,0,0,1,.4.711c.008.016.016.031.023.048.041.1.076.2.112.3s.064.172.091.263.056.2.083.307.053.215.077.329.04.209.059.318c.022.133.041.267.059.4.014.1.027.209.038.318.016.164.029.337.04.513.006.1.014.187.018.286.012.28.02.569.02.876C497.255,113.557,495.437,115.523,492.184,115.579Z"
            ></path>
            <path
              className="dCookies"
              d="M502.242,103.74c-.254-.139-.5-.289-.74-.446q-.383-.25-.745-.528l-.012-.009c-.156-.12-.312-.239-.461-.366s-.307-.271-.456-.411a11.882,11.882,0,0,1-2.4-3.217c-.035-.068-.063-.139-.1-.207a10.886,10.886,0,0,0-1.731-.312c.067.172.117.35.192.519a13.2,13.2,0,0,0,3.306,4.531c.017.015.032.032.05.047.152.134.3.268.463.4s.32.24.482.358.293.229.45.333c.066.044.137.079.2.122.276.175.554.346.841.5.174.094.354.174.531.26q.234.114.471.221c.022.01.044.021.066.03.04.018.082.029.123.046a14.249,14.249,0,0,0-.359-1.782C502.359,103.8,502.3,103.771,502.242,103.74Z"
            ></path>
          </g>
        </svg>
      );
    if (select === "close")
      return (
        <svg width="12" height="12.002" viewBox="0 0 12 12.002" id="closebtnRechercherHeader">
          <defs></defs>
          <g transform="translate(-24.125 -24.265)">
            <g transform="translate(24.125 24.265)">
              <path
                className="u"
                fill="#fff"
                d="M31.129,30.25l4.809-4.809a.7.7,0,0,0-.986-.986l-4.809,4.809-4.809-4.812a.7.7,0,0,0-.986.986l4.809,4.812-4.809,4.809a.7.7,0,1,0,.986.986l4.809-4.809,4.809,4.809a.7.7,0,0,0,.986-.986Z"
                transform="translate(-24.125 -24.265)"
              />
            </g>
          </g>
        </svg>
      );
    if (select === "hexa_valid")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="39.201" height="33.949" viewBox="0 0 39.201 33.949">
          <g className="icon_reassurance" transform="translate(1.732 1.5)">
            <path
              id="Tracé_68"
              data-name="Tracé 68"
              d="M9569.3,2436.321l5,5.232,8.7-9.51"
              transform="translate(-9558 -2421.553)"
              fill="none"
              stroke="#ffd400"
              strokeWidth="2"
            ></path>
            <path
              id="Tracé_69"
              data-name="Tracé 69"
              d="M68.36,125.717H50.491l-8.934,15.475,8.934,15.475H68.36l8.934-15.475Z"
              transform="translate(-41.557 -125.717)"
              fill="none"
              stroke="#ffd400"
              strokeMiterlimit="10"
              strokeWidth="3"
            ></path>
          </g>
        </svg>
      );
    if (select === "valide")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13.272" height="9.736" viewBox="0 0 13.272 9.736">
          <path
            className="abcdef"
            stroke="#ffd400"
            fill="none"
            style={{ strokeLinecap: "round", strokeWidth: "2px" }}
            d="M4662.476,163.947l3.964,3.359,6.485-6.943"
            transform="translate(-4661.066 -158.95)"
          ></path>
        </svg>
      );
    if (select === "arrow_up")
      return (
        <svg
          id="e8efsweu87931"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 25 25"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
          width="25"
          height="25"
        >
          <g id="e8efsweu87932_to" transform="translate(12.500000,16.156055)">
            <path
              id="e8efsweu87932"
              d="M10.891000,4.844010C10.668153,4.618934,10.305056,4.617143,10.080000,4.840010C9.854944,5.062876,9.853153,5.426005,10.076000,5.651081L14.209000,9.784447L0.571000,9.784447C0.419317,9.783643,0.273613,9.843549,0.166355,9.950817C0.059097,10.058084,-0.000803,10.203800,-0,10.355497C-0.001331,10.508091,0.058144,10.654935,0.165285,10.763587C0.272427,10.872239,0.418416,10.933756,0.571000,10.934548L14.209000,10.934548L10.076000,15.059913C9.855633,15.286911,9.855633,15.647987,10.076000,15.874985C10.183373,15.984386,10.330218,16.046019,10.483500,16.046019C10.636782,16.046019,10.783627,15.984386,10.891000,15.874985L16,10.763533C16.109440,10.657812,16.171245,10.512168,16.171245,10.359997C16.171245,10.207826,16.109440,10.062183,16,9.956462Z"
              transform="rotate(-90) scale(1.093785,1.001790) translate(-8.085612,-10.360022)"
              fill="#262626"
              stroke="none"
              strokeWidth="1"
            ></path>
          </g>
        </svg>
      );
    if (select === "hours")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
          <path
            d="M21,964.362a9,9,0,1,0,9,9A9.007,9.007,0,0,0,21,964.362Zm0,.947a8.053,8.053,0,1,1-8.053,8.053A8.046,8.046,0,0,1,21,965.31Zm0,1.658a.474.474,0,0,0-.474.474v5.921a.474.474,0,0,0,.474.474h5.447a.474.474,0,1,0,0-.947H21.474v-5.448A.474.474,0,0,0,21,966.967Z"
            transform="translate(-12 -964.362)"
          ></path>
        </svg>
      );
    if (select === "calendrier")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21.056" viewBox="0 0 20 21.056">
          <path
            d="M29.437,32.915H25V17.986h4.789V17h.986v.986h3.732V17h.915v.986h3.8V17h.915v.986H45v14.93H40.563A5.647,5.647,0,0,1,35,38.056,5.547,5.547,0,0,1,29.437,32.915ZM25.915,32h3.521A5.547,5.547,0,0,1,35,26.859,5.647,5.647,0,0,1,40.563,32h3.451V22.775h-18.1Zm0-13.1v2.887h18.1V18.9H40.141v.986h-.915V18.9h-3.8v.986h-.915V18.9H30.775v.986h-.986V18.9ZM35,27.845a4.648,4.648,0,0,0,0,9.3,4.648,4.648,0,1,0,0-9.3Zm.423,2.817v1.479l2.535.634-.282.915-3.169-.845V30.662Z"
            transform="translate(-25 -17)"
          ></path>
        </svg>
      );
    if (select === "delete")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
          <g className="aaa" fill="none" stroke="#868686">
            <circle className="ccc" stroke="none" cx="15" cy="15" r="15"></circle>
            <circle className="d" fill="none" cx="15" cy="15" r="14.5"></circle>
          </g>
          <g transform="translate(10 7.952)">
            <path
              className="bbb"
              fill="#868686"
              d="M19.235,4a.887.887,0,0,0-.882.882v.588H16.882A.887.887,0,0,0,16,6.353V7.382a.887.887,0,0,0,.882.882h.147v8.382a.887.887,0,0,0,.882.882h6.176a.887.887,0,0,0,.882-.882V8.265h.147A.887.887,0,0,0,26,7.382V6.353a.887.887,0,0,0-.882-.882H23.647V4.882A.887.887,0,0,0,22.765,4Zm0,.588h3.529a.287.287,0,0,1,.294.294v.588H18.941V4.882A.287.287,0,0,1,19.235,4.588ZM16.882,6.059h8.235a.287.287,0,0,1,.294.294V7.382a.287.287,0,0,1-.294.294H16.882a.287.287,0,0,1-.294-.294V6.353A.287.287,0,0,1,16.882,6.059Zm.735,2.206h6.765v8.382a.287.287,0,0,1-.294.294H17.912a.287.287,0,0,1-.294-.294ZM19.13,9.878a.294.294,0,0,0-.262.3v5a.294.294,0,1,0,.588,0v-5a.294.294,0,0,0-.326-.3Zm1.838,0a.294.294,0,0,0-.262.3v5a.294.294,0,1,0,.588,0v-5a.294.294,0,0,0-.326-.3Zm1.838,0a.294.294,0,0,0-.262.3v5a.294.294,0,1,0,.588,0v-5a.294.294,0,0,0-.326-.3Z"
              transform="translate(-16 -4)"
            ></path>
          </g>
        </svg>
      );
    if (select === "search")
      return (
        <svg id="openbtnRechercherHeader" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
          <path
            className="m"
            fill="#262626"
            d="M22.853,22.148l-2.885-2.885a5.053,5.053,0,1,0-.708.708l2.885,2.882a.5.5,0,1,0,.708-.705Zm-6.8-2.04a4.052,4.052,0,1,1,4.053-4.051A4.056,4.056,0,0,1,16.057,20.108Z"
            transform="translate(-11 -11)"
          ></path>
        </svg>
      );
    if (select === "carottage")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51.39 51.39">
          <g id="scie_icon" data-name="Calque 2">
            <g id="scie_icon2" data-name="Calque 1">
              <path
                className="cls-1"
                fill="#a1a1a1"
                d="M25.65,37h-.19l-.46,0,0-2.15a9.18,9.18,0,0,1-2.09-.39,3.45,3.45,0,0,1-.26.28,2.41,2.41,0,0,1-1.19.6,3.15,3.15,0,0,1-1.46,0,4,4,0,0,1-.72-.26,5.52,5.52,0,0,1-.7-.44l-.81-.69,1.47-1.7A9,9,0,0,1,18,30.54a2.51,2.51,0,0,1-1.78-.24,2.44,2.44,0,0,1-.59-.4,3.67,3.67,0,0,1-.49-.54,3.89,3.89,0,0,1-.66-1.46l-.18-1.06,2.34-.37q0-.39,0-.78a10,10,0,0,1,.08-1.21,2.46,2.46,0,0,1-1.34-1.38,3.41,3.41,0,0,1-.2-.67,3.91,3.91,0,0,1,.41-2.28c.05-.11.14-.26.29-.51l.26-.42,2.13,1.27A9.64,9.64,0,0,1,19.48,19a2.51,2.51,0,0,1-.26-.69A2.56,2.56,0,0,1,19.29,17a2.19,2.19,0,0,1,.12-.33,3.41,3.41,0,0,1,.17-.33A5.69,5.69,0,0,1,20,15.8a3.48,3.48,0,0,1,.59-.5,3.72,3.72,0,0,1,.78-.42l1-.35.84,2.41a8.51,8.51,0,0,1,1.88-.33,2.48,2.48,0,0,1,1.14-1.68,2.31,2.31,0,0,1,.65-.31,3.88,3.88,0,0,1,.71-.17,3.57,3.57,0,0,1,.8,0,4.2,4.2,0,0,1,.84.18l1,.35-.89,2.35a9.42,9.42,0,0,1,1.69,1,2.52,2.52,0,0,1,1.9-.53,3.41,3.41,0,0,1,1.35.52,4.34,4.34,0,0,1,.61.51,4.12,4.12,0,0,1,.28.31c.09.12.16.24.24.35l.54.9-2.12,1.18a9.12,9.12,0,0,1,.72,1.88,2.54,2.54,0,0,1,1.67.82,3.39,3.39,0,0,1,.7,1.27h0a6,6,0,0,1,.13.76,3.22,3.22,0,0,1,0,.43c0,.14,0,.27,0,.41l-.16,1-2.26-.43a8.46,8.46,0,0,1-.69,2,2.56,2.56,0,0,1,.66,1.62A3.55,3.55,0,0,1,33.3,34l-.44.39-.38.25L31.12,33a8.92,8.92,0,0,1-1.84,1.07c0,.12,0,.24,0,.36a3,3,0,0,1-.17.64,2.42,2.42,0,0,1-.35.58,3.15,3.15,0,0,1-1.15.92,4.71,4.71,0,0,1-.71.27,4.82,4.82,0,0,1-.83.1l-.26,0Zm-3.14-3.8.4.15a8.06,8.06,0,0,0,2.63.49H26L26,36a4.16,4.16,0,0,0,.63-.09,2.86,2.86,0,0,0,.53-.2A2.17,2.17,0,0,0,28,35a1.35,1.35,0,0,0,.21-.35,1.4,1.4,0,0,0,.1-.39,1.25,1.25,0,0,0,0-.47l-.08-.41.39-.14a8,8,0,0,0,2.32-1.36l.39-.32,1.37,1.68h0a2.49,2.49,0,0,0,.9-1.93A1.53,1.53,0,0,0,33,30.19l-.34-.26.2-.38a7.57,7.57,0,0,0,.86-2.5l.09-.5L36,27h0c0-.11,0-.21,0-.32a1.15,1.15,0,0,0,0-.26,3.26,3.26,0,0,0-.1-.6,2.52,2.52,0,0,0-.48-.88,1.53,1.53,0,0,0-1.28-.49l-.44,0-.1-.44a7.93,7.93,0,0,0-.93-2.42l-.26-.44L34.52,20h0a2.11,2.11,0,0,0-.18-.27l-.19-.2a3.22,3.22,0,0,0-.45-.39,2.49,2.49,0,0,0-.92-.35,1.48,1.48,0,0,0-1.37.51l-.31.36-.38-.3a8,8,0,0,0-2.23-1.25L28,17.91l.89-2.33h0a2.68,2.68,0,0,0-.59-.12,2.58,2.58,0,0,0-.55,0,2.88,2.88,0,0,0-.56.13,1.35,1.35,0,0,0-.4.19A1.53,1.53,0,0,0,26,17.09v.49h-.5a8.11,8.11,0,0,0-2.5.44l-.47.16-.83-2.37h0a1.94,1.94,0,0,0-.49.26,2.51,2.51,0,0,0-.46.37,2.66,2.66,0,0,0-.34.45,1.13,1.13,0,0,0-.12.21c0,.06-.05.14-.08.21a1.61,1.61,0,0,0,0,.81,1.58,1.58,0,0,0,.33.66l.32.38-.38.32a8.29,8.29,0,0,0-1.67,1.93l-.26.42-2.1-1.26a2.79,2.79,0,0,0-.33,1.13,3.4,3.4,0,0,0,0,.56,2.52,2.52,0,0,0,.14.45,1.5,1.5,0,0,0,1.08.92l.47.1-.09.48a8.08,8.08,0,0,0-.13,1.46,8.83,8.83,0,0,0,.08,1.13l.07.48-2.31.37a3,3,0,0,0,.48,1.08,2.49,2.49,0,0,0,.37.41,1.64,1.64,0,0,0,.39.26,1.49,1.49,0,0,0,1.33.06l.42-.19.22.4a8.17,8.17,0,0,0,1.65,2l.37.32-1.44,1.67a2.79,2.79,0,0,0,.53.34,3.46,3.46,0,0,0,.54.19,2.13,2.13,0,0,0,1,0,1.5,1.5,0,0,0,.71-.36,1.26,1.26,0,0,0,.3-.38ZM25.69,28A2.35,2.35,0,1,1,28,25.69,2.35,2.35,0,0,1,25.69,28Zm0-3.7A1.35,1.35,0,1,0,27,25.69,1.36,1.36,0,0,0,25.69,24.34Z"
              ></path>
            </g>
          </g>
        </svg>
      );
    if (select === "tout-terrain")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51.39 51.39">
          <g id="manutentiontt_icon" data-name="Calque 2">
            <g id="manutentiontt_icon2" data-name="Calque 1">
              <path
                className="cls-1"
                fill="#a1a1a1"
                d="M11.42,31.06a4.38,4.38,0,1,0,4.37,4.37A4.38,4.38,0,0,0,11.42,31.06Zm0,7.75a3.38,3.38,0,1,1,3.37-3.38A3.39,3.39,0,0,1,11.42,38.81Z"
              ></path>
              <path
                className="cls-1"
                fill="#a1a1a1"
                d="M11.42,33.53a1.91,1.91,0,1,0,1.9,1.9A1.9,1.9,0,0,0,11.42,33.53Zm0,2.81a.91.91,0,1,1,0-1.81.91.91,0,0,1,0,1.81Z"
              ></path>
              <path
                className="cls-1"
                fill="#a1a1a1"
                d="M34.12,31.06a4.38,4.38,0,1,0,4.37,4.37A4.37,4.37,0,0,0,34.12,31.06Zm0,7.75a3.38,3.38,0,1,1,3.37-3.38A3.38,3.38,0,0,1,34.12,38.81Z"
              ></path>
              <path
                className="cls-1"
                fill="#a1a1a1"
                d="M34.12,33.53A1.91,1.91,0,1,0,36,35.43,1.91,1.91,0,0,0,34.12,33.53Zm0,2.81a.91.91,0,1,1,.91-.91A.91.91,0,0,1,34.12,36.34Z"
              ></path>
              <path
                className="cls-1"
                fill="#a1a1a1"
                d="M46.9,17.08H42.45a.93.93,0,0,1-.84-.54l-.81-1.3V12.08a.5.5,0,0,0-.5-.5.51.51,0,0,0-.5.5V14.7l-2.73-2.18,0,0,0,0h0a.44.44,0,0,0-.15-.05h-.08l-.17,0h0l-14.33,7H17.68a2,2,0,0,0-1.43.59l-.48.48A2.09,2.09,0,0,0,15.14,22v.87L8.29,26.24a1.59,1.59,0,0,0-.89,1.43v2.45A5.16,5.16,0,0,0,6,31.69a.5.5,0,0,0,.22.67.5.5,0,0,0,.67-.22C7,32,8.27,29.63,12.05,29.6h.12a4.53,4.53,0,0,1,3.73,2.54,8.27,8.27,0,0,1,.65,3.29v.5H28.81v-.49a6.11,6.11,0,0,1,2.62-4.53,5.23,5.23,0,0,1,5.78,0,.5.5,0,0,0,.51-.86,7.56,7.56,0,0,0-1.39-.66l-.56-1.09a3.32,3.32,0,0,0-2.26-1.27l-3-.33-.69-2.4a4.48,4.48,0,0,0-1.14-1.95l-1.7-1.7,9.76-5.07,3.1,2.48v.59a.5.5,0,0,0,.5.5.51.51,0,0,0,.47-.32v-.07a.36.36,0,0,0,0-.11V17.11a1.89,1.89,0,0,0,1.65,1H46.9a.5.5,0,0,0,.5-.5A.5.5,0,0,0,46.9,17.08ZM15.14,25.14,12,25.55,15.14,24Zm18.27,2.92a2.29,2.29,0,0,1,1.52.8l.13.25a6.11,6.11,0,0,0-4.23,1,7.37,7.37,0,0,0-3,4.82H17.53a8.69,8.69,0,0,0-.74-3.24,5.54,5.54,0,0,0-4.56-3.09h-.18a7.6,7.6,0,0,0-3.65.87v-1.8a.6.6,0,0,1,.32-.53l.6-.29a.57.57,0,0,0,.18,0h.07l5.83-.76,3.69,5.53a1.71,1.71,0,0,0,1.42.77h5.62a3.54,3.54,0,0,0,2.79-1.35l2-2.57-.21-.73ZM28.82,24.6l1.05,3.68-1.73,2.17a2.57,2.57,0,0,1-2,1H20.51a.7.7,0,0,1-.59-.32l-3.78-5.67V22a1.14,1.14,0,0,1,.33-.8l.49-.48a1,1,0,0,1,.72-.3h6.5a2.71,2.71,0,0,1,1.9.78l1.85,1.86A3.47,3.47,0,0,1,28.82,24.6Zm7.44-9.89L26.09,20a3.68,3.68,0,0,0-1.65-.52l11.82-5.76Zm3.52,2.08-2.52-2V14l2.52,2Z"
              ></path>
              <path className="cls-1" fill="#a1a1a1" d="M21.27,27.19H19.86a.5.5,0,0,0,0,1h1.41a.5.5,0,0,0,0-1Z"></path>
            </g>
          </g>
        </svg>
      );
    if (select === "demolition")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51.39 51.39">
          <g id="demolition_icon" data-name="Calque 2">
            <g id="demolition_icon2" data-name="Calque 1">
              <path
                className="cls-1"
                fill="#a1a1a1"
                d="M35.4,13.64H30.56v-.3a1.82,1.82,0,0,0-1.85-1.79h-6a1.82,1.82,0,0,0-1.85,1.79V14H16v2.93h4.85V17a1.76,1.76,0,0,0,.44,1.15L23,20.07v2.16h.79V34H25.2v7.37h1V34h1.45V22.23h.79V20.07l1.68-1.88A1.76,1.76,0,0,0,30.56,17v-.47H35.4ZM20.83,15.88H17V15h3.84Zm6.61,4.65V21H24v-.5ZM26.65,33h-1.9V22.23h1.9ZM29.56,17a.71.71,0,0,1-.19.48l-1.79,2H23.82l-1.79-2a.71.71,0,0,1-.19-.48v-3.7a.82.82,0,0,1,.85-.79h6a.82.82,0,0,1,.85.79V17Zm4.84-1.47H30.56v-.93H34.4Z"
              ></path>
              <path className="cls-1" fill="#a1a1a1" d="M25.78,14.77a.89.89,0,0,0,0,1.77.89.89,0,1,0,0-1.77Z"></path>
            </g>
          </g>
        </svg>
      );
    if (select === "remblayage")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51.39 51.39">
          <g id="remblayage_icon" data-name="Calque 2">
            <g id="remblayage_icon2" data-name="Calque 1">
              <path
                className="cls-1"
                fill="#a1a1a1"
                d="M44.14,24.74h-.49l-1.72-8.59a.49.49,0,0,0-.49-.41h-9.9a.5.5,0,0,0-.48.4L29.54,23l-.2,0V15.34a.5.5,0,0,0-.5-.5h-.9a.51.51,0,0,0-.5.5.5.5,0,0,0,.5.5h.4v7.3l-4.2.6a3,3,0,0,0-1.58.74L13.1,32.31a1,1,0,0,0-.22-.34L10.3,29.39a.53.53,0,0,0-.36-.15H9a.51.51,0,0,0-.5.5v1.71L6.78,35.86a.5.5,0,0,0,0,.46.49.49,0,0,0,.41.22h4.94a1.25,1.25,0,0,0,1.12-.68l.18-.36s0,0,0,0h.05l6.5-4.69a3.64,3.64,0,1,0,6.59,2.19H34a5,5,0,0,0,9.77-1.4,4.93,4.93,0,0,0-.69-2.49l.94-.47a1.18,1.18,0,0,0,.65-1.06V25.24A.5.5,0,0,0,44.14,24.74ZM32,16.74H41l1.6,8H36.94c-2.52,0-3.63,2.61-4,3.6H31.88l-1.61-4Zm-8.74,8.49a2,2,0,0,1,1.07-.5l5-.72,0,.23a.42.42,0,0,0,0,.29l.41,1-5.44,1a.52.52,0,0,0-.2.09L13.6,34.17l-.2-.8ZM12.59,35l-.18.37a.25.25,0,0,1-.23.13H8l1.51-3.75a1.06,1.06,0,0,0,0-.31V30.24h.2l2.46,2.49.45,1.76A.75.75,0,0,1,12.59,35Zm12-7.52,5.52-1,.74,1.84H28a1.47,1.47,0,0,0-1.46,1.46v2.14h0A3.64,3.64,0,0,0,23,29.24a3.41,3.41,0,0,0-1.11.2Zm-1.56,8a2.65,2.65,0,1,1,2.65-2.65A2.65,2.65,0,0,1,23,35.54Zm15.75,0a4,4,0,1,1,4-4A4,4,0,0,1,38.74,35.54Zm4.9-8a.21.21,0,0,1-.1.17l-1.08.54a5,5,0,0,0-8.72,3.31c0,.14,0,.27,0,.4H27.54V29.8a.47.47,0,0,1,.46-.46h5.34a.5.5,0,0,0,.49-.37s.84-3.23,3.11-3.23h6.7Z"
              ></path>
              <path
                className="cls-1"
                fill="#a1a1a1"
                d="M23,31a1.85,1.85,0,1,0,1.85,1.85A1.85,1.85,0,0,0,23,31Zm0,2.7a.85.85,0,1,1,.85-.85A.86.86,0,0,1,23,33.74Z"
              ></path>
              <path
                className="cls-1"
                fill="#a1a1a1"
                d="M38.74,29.24a2.3,2.3,0,1,0,2.3,2.3A2.31,2.31,0,0,0,38.74,29.24Zm0,3.6a1.3,1.3,0,1,1,1.3-1.3A1.3,1.3,0,0,1,38.74,32.84Z"
              ></path>
            </g>
          </g>
        </svg>
      );
    if (select === "espace")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51.39 51.39">
          <g id="espacevert_icon" data-name="Calque 2">
            <g id="espacevert_icon2" data-name="Calque 1">
              <path
                className="cls-1"
                fill="#a1a1a1"
                d="M32,20.38a1.82,1.82,0,0,1-.92-1.59c0-.12,0-.23,0-.33a5.41,5.41,0,0,0-5.24-5.1,5.31,5.31,0,0,0-3.88,1.54,5.43,5.43,0,0,0-1.61,3.92,1.8,1.8,0,0,1-.92,1.56,5.4,5.4,0,0,0,2.5,10.11,5.25,5.25,0,0,0,1.36-.15c.45-.11,1.28-.25,1.93-.34v7H22.54a.5.5,0,0,0-.5.5.51.51,0,0,0,.5.5h6.3a.5.5,0,0,0,.5-.5.5.5,0,0,0-.5-.5H26.19V30c.7.1,1.63.31,1.94.39a5.82,5.82,0,0,0,1.24.14h.12A5.4,5.4,0,0,0,32,20.38Zm-2.5,9.11h-.11a4.71,4.71,0,0,1-1-.11A18.89,18.89,0,0,0,26.19,29V26.82l4.45-3a.51.51,0,0,0,.14-.7.5.5,0,0,0-.7-.13l-3.89,2.59V20.33a.5.5,0,0,0-.5-.5.5.5,0,0,0-.5.5v5.29L21.31,23a.5.5,0,0,0-.7.13.51.51,0,0,0,.14.7l4.44,3V29c-.74.1-1.7.27-2.17.38a4.08,4.08,0,0,1-1.1.12,4.4,4.4,0,0,1-2-8.24,2.82,2.82,0,0,0,1.43-2.49,4.4,4.4,0,0,1,1.32-3.15,4.31,4.31,0,0,1,3.15-1.25,4.4,4.4,0,0,1,4.26,4.17,2.26,2.26,0,0,1,0,.26,2.81,2.81,0,0,0,1.43,2.46,4.4,4.4,0,0,1-2,8.24Z"
              ></path>
            </g>
          </g>
        </svg>
      );
    if (select === "industrielle")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51.39 51.39">
          <g id="manutentionind_icon" data-name="Calque 2">
            <g id="manutentionind_icon2" data-name="Calque 1">
              <path
                className="cls-1"
                fill="#a1a1a1"
                d="M36.67,32.57A1.47,1.47,0,1,0,38.15,34,1.47,1.47,0,0,0,36.67,32.57Zm0,1.94a.47.47,0,0,1,0-.94.47.47,0,1,1,0,.94Z"
              ></path>
              <path
                className="cls-1"
                fill="#a1a1a1"
                d="M24.3,30.71a2.12,2.12,0,1,0,2.12,2.12A2.12,2.12,0,0,0,24.3,30.71Zm0,3.24a1.12,1.12,0,1,1,1.12-1.12A1.12,1.12,0,0,1,24.3,34Z"
              ></path>
              <path
                className="cls-1"
                fill="#a1a1a1"
                d="M18.49,14a.51.51,0,0,0-.5.5v19.8a.5.5,0,0,0,.5.5.5.5,0,0,0,.5-.5V14.51A.5.5,0,0,0,18.49,14Z"
              ></path>
              <path
                className="cls-1"
                fill="#a1a1a1"
                d="M16.69,26.61a.51.51,0,0,0-.5.5v6.7H9.49a.51.51,0,0,0-.5.5.5.5,0,0,0,.5.5h7.2a.5.5,0,0,0,.5-.5v-7.2A.5.5,0,0,0,16.69,26.61Z"
              ></path>
              <path
                className="cls-1"
                fill="#a1a1a1"
                d="M40.09,23h-1.3V19a3.08,3.08,0,0,0-3.2-3.2H32a5,5,0,0,0-5,3l-2.59,7.76H22.17a2.52,2.52,0,0,0-2.48,2.58v3a.45.45,0,0,0,.1.28c0,.12,0,.23,0,.36a4.54,4.54,0,0,0,8.63,2h5.06a3.32,3.32,0,0,0,6.47,0,3.14,3.14,0,0,0,2.48-3.22v-6.3A2.23,2.23,0,0,0,40.09,23ZM28,19.17a4,4,0,0,1,4-2.36h3.6a2.11,2.11,0,0,1,2.2,2.2v4h-2.2a3.5,3.5,0,0,0-2.1,1L30,26.61H25.49ZM24.3,36.38a3.55,3.55,0,1,1,3.55-3.55A3.56,3.56,0,0,1,24.3,36.38Zm12.37,0A2.34,2.34,0,1,1,39,34,2.34,2.34,0,0,1,36.67,36.38Zm4.72-4.77c0,.08,0,1.78-1.41,2.18a3.32,3.32,0,0,0-6.62,0H28.74a4.54,4.54,0,0,0-8-3.73v-.89a1.54,1.54,0,0,1,1.5-1.58h8a.45.45,0,0,0,.3-.1l3.66-2.74A2.57,2.57,0,0,1,35.59,24h4.5a1.24,1.24,0,0,1,1.3,1.3Z"
              ></path>
              <path
                className="cls-1"
                fill="#a1a1a1"
                d="M39.09,25.71h-2.6a.51.51,0,0,0-.5.5.5.5,0,0,0,.5.5h2.6a.5.5,0,0,0,.5-.5A.5.5,0,0,0,39.09,25.71Z"
              ></path>
            </g>
          </g>
        </svg>
      );
    if (select === "elevation")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51.39 51.39">
          <g id="elevation_icon" data-name="Calque 2">
            <g id="Calque_1-2" data-name="Calque 1">
              <path
                className="cls-1"
                fill="#a1a1a1"
                d="M33.59,20.45a.49.49,0,0,0,.36-.37h1.5a.5.5,0,0,0,.5-.5V13.36a.5.5,0,0,0-.5-.5H15.94a.5.5,0,0,0-.5.5v6.22a.5.5,0,0,0,.5.5h1.93a.49.49,0,0,0,.36.37l5.49,1.28L18.51,23h-.05a.5.5,0,0,0-.6.37.33.33,0,0,0,0,.1s0,0,0,.06,0,0,0,.05a.34.34,0,0,0,0,.1.49.49,0,0,0,.49.38h.16l5.21,1.22-5.43,1.27H15.94a.5.5,0,0,0-.5.5v8.22a.5.5,0,0,0,.5.5h1.23a3.31,3.31,0,0,0,6.56,0H27.3a3.31,3.31,0,0,0,6.56,0h1.59a.5.5,0,0,0,.5-.5V27a.5.5,0,0,0-.5-.5H33.53L28.1,25.2,33.31,24h.16a.49.49,0,0,0,.49-.38.34.34,0,0,0,0-.1s0,0,0-.05,0,0,0-.06a.33.33,0,0,0,0-.1.5.5,0,0,0-.6-.37h0L28.1,21.73ZM35,19.08H26.19V13.86H35ZM16.44,13.86h8.75v5.22H16.44Zm4.61,6.22h9.72l-4.86,1.14Zm-.6,17.45a2.33,2.33,0,1,1,2.33-2.33A2.34,2.34,0,0,1,20.45,37.53Zm10.13,0a2.33,2.33,0,1,1,2.33-2.33A2.34,2.34,0,0,1,30.58,37.53ZM35,34.69H33.86a3.32,3.32,0,0,0-6.56,0H23.73a3.31,3.31,0,0,0-6.55,0h-.74V29.47H35Zm0-6.22H16.44v-1H35Zm-5.8-2H22.67l3.24-.76Zm2-3-5.21,1.22L20.7,23.47l5.21-1.22Z"
              ></path>
            </g>
          </g>
        </svg>
      );
    if (select === "compactage")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51.39 51.39">
          <g id="compactage_icon1" data-name="Calque 2">
            <g id="compactage_icon2" data-name="Calque 1">
              <path
                className="cls-1"
                fill="#a1a1a1"
                d="M40.54,14.74h-3.3a.46.46,0,0,0-.3.11L30,20.22V18.54a1.6,1.6,0,0,0-1.6-1.6H24a1.6,1.6,0,0,0-1.6,1.6v.6H11.94a.51.51,0,0,0-.5.5v7.23a1.2,1.2,0,0,0-1.1,1.18v2.8L11.47,32a4.87,4.87,0,0,0,9.72.27h1.3A4.88,4.88,0,0,0,32.22,32l1.12-1.12V28.17a1.31,1.31,0,0,0-1.1-1.28V25.21a2.48,2.48,0,0,0-.68-1.7l7-5.57h2a.5.5,0,0,0,.5-.5v-2.2A.5.5,0,0,0,40.54,14.74Zm-17.1,3.8a.6.6,0,0,1,.6-.6h4.4a.6.6,0,0,1,.6.6v3.38l-4.28-2.45a2.59,2.59,0,0,0-1.25-.33h-.07Zm.07,1.6a1.53,1.53,0,0,1,.75.2l6.22,3.56a1.51,1.51,0,0,1,.76,1.31v1.63H12.44v-6.7Zm-7.17,15.5a3.89,3.89,0,0,1-3.85-3.4H13.7a2.69,2.69,0,0,0,5.29,0h1.2A3.88,3.88,0,0,1,16.34,35.64Zm-1.61-3.4H18a1.69,1.69,0,0,1-3.23,0Zm12.61,3.4a3.89,3.89,0,0,1-3.85-3.4H24.7a2.69,2.69,0,0,0,5.29,0h1.2A3.88,3.88,0,0,1,27.34,35.64Zm-1.61-3.4H29a1.69,1.69,0,0,1-3.23,0Zm6.61-4.07v2.27l-.8.8H12.15l-.81-.8V28.05a.22.22,0,0,1,.21-.21H32A.32.32,0,0,1,32.34,28.17ZM40,16.94h-1.7a.51.51,0,0,0-.31.11l-7.29,5.84L30,22.5v-1l7.38-5.75H40Z"
              ></path>
            </g>
          </g>
        </svg>
      );
    if (select === "terrassement")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51.39 51.39">
          <g id="terrassement_icon" data-name="Calque 2">
            <g id="terrassement_icon2" data-name="Calque 1">
              <path
                className="cls-1"
                fill="#a1a1a1"
                d="M37.36,32.83H22.41a3.21,3.21,0,0,0,0,6.41h15a3.21,3.21,0,0,0,0-6.41Zm0,5.41H22.41a2.21,2.21,0,0,1,0-4.41h15a2.21,2.21,0,0,1,0,4.41Z"
              ></path>
              <path
                className="cls-1"
                fill="#a1a1a1"
                d="M22.57,34.27A1.77,1.77,0,1,0,24.34,36,1.77,1.77,0,0,0,22.57,34.27Zm0,2.54a.77.77,0,0,1,0-1.54.77.77,0,0,1,0,1.54Z"
              ></path>
              <path
                className="cls-1"
                fill="#a1a1a1"
                d="M37,34.27A1.77,1.77,0,1,0,38.8,36,1.77,1.77,0,0,0,37,34.27Zm0,2.54A.77.77,0,1,1,37.8,36,.78.78,0,0,1,37,36.81Z"
              ></path>
              <path
                className="cls-1"
                fill="#a1a1a1"
                d="M17.31,24.93a.82.82,0,0,0-.6.47.42.42,0,0,1-.12.14.59.59,0,0,1-.3.06h-3.5l2.52-7.49,8.47,13a.47.47,0,0,0,.13.12,1.85,1.85,0,0,0,1.64,1h12.6A1.85,1.85,0,0,0,40,30.34a1.53,1.53,0,0,0,0-.3.4.4,0,0,0,0-.15v-5.4a1.55,1.55,0,0,0-.63-1.37A1.38,1.38,0,0,0,39.1,23V18.29A2.24,2.24,0,0,0,36.8,16H30.45a3.76,3.76,0,0,0-1.83.48A5.19,5.19,0,0,0,26,20L25,25.33,14.65,12.62a1.28,1.28,0,0,0-1.56-.34,1.23,1.23,0,0,0-.6.78s0,0,0,.06h0L10.93,25.83a.51.51,0,0,0-.09.27v1A2.82,2.82,0,0,0,13.66,30H15.2A2.82,2.82,0,0,0,18,27.13V25.5a.5.5,0,0,0-.14-.35A.65.65,0,0,0,17.31,24.93ZM12.1,24.5,13.26,15l1.35,2.07Zm12.6,5.84a.85.85,0,0,1,.85-.85h7.29l.57,1.7H25.55A.85.85,0,0,1,24.7,30.34ZM38.81,24s.19.13.19.54v4.22a1.76,1.76,0,0,0-.85-.22H33.7v-1.3A2.68,2.68,0,0,1,35.19,25L37.45,24C37.75,23.9,38.49,23.73,38.81,24Zm-.66,7.24H34.46l-.57-1.7h4.26a.85.85,0,1,1,0,1.7ZM27,20.21a4.22,4.22,0,0,1,2.09-2.87A2.77,2.77,0,0,1,30.45,17H36.8a1.25,1.25,0,0,1,1.3,1.3v4.57a4.22,4.22,0,0,0-1,.22l-2.3,1a3.68,3.68,0,0,0-2.08,3.15v1.3H26.23a2.47,2.47,0,0,1-.63-1.26ZM13.57,13.15s.15-.07.32.12L24.71,26.61h0l-.12.58A3,3,0,0,0,25,28.57a1.82,1.82,0,0,0-1.11.9L13.53,13.56C13.36,13.28,13.53,13.18,13.57,13.15Zm3.45,14A1.81,1.81,0,0,1,15.2,29H13.66a1.82,1.82,0,0,1-1.82-1.82V26.6h4.44a1.47,1.47,0,0,0,.74-.16Z"
              ></path>
            </g>
          </g>
        </svg>
      );
    if (select === "page")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
          <g id="Ellipse_60" data-name="Ellipse 60" fill="none" stroke="#ffd400" strokeWidth="1">
            <circle cx="12.5" cy="12.5" r="12.5" stroke="none"></circle>
            <circle cx="12.5" cy="12.5" r="12" fill="none"></circle>
          </g>
          <g className="icon_catalogue_a" fill="none">
            <circle className="icon_catalogue_c" stroke="none" cx="12.5" cy="12.5" r="12.5"></circle>
            <circle className="icon_catalogue_d" fill="none" cx="12.5" cy="12.5" r="12"></circle>
          </g>
          <g transform="translate(4 -76.176)">
            <path
              className="icon_catalogue_b"
              fill="#ffd400"
              d="M14.427,6.572c-3.413-1.387-5.251.1-6.048,1.1A4.511,4.511,0,0,0,3.2,6.273a8.785,8.785,0,0,0-.872.3h0a.512.512,0,0,0-.159.1.609.609,0,0,0-.074.1.641.641,0,0,0-.054.092A.532.532,0,0,0,2,7.057H2v8.505H2v.013a.506.506,0,0,0,.032.155.076.076,0,0,0,.008.041h0a.532.532,0,0,0,.492.335.518.518,0,0,0,.218-.049c3.814-1.539,5.071,1.159,5.139,1.313.007.015.019.027.025.041a.5.5,0,0,0,.074.11.592.592,0,0,0,.062.054.509.509,0,0,0,.078.053.448.448,0,0,0,.081.037.482.482,0,0,0,.108.021.473.473,0,0,0,.061.013.544.544,0,0,0,.064-.013.486.486,0,0,0,.106-.021.46.46,0,0,0,.082-.037.725.725,0,0,0,.077-.053.483.483,0,0,0,.062-.054.549.549,0,0,0,.073-.108c.008-.016.02-.028.027-.044.057-.133,1.285-2.881,5.156-1.306a.532.532,0,0,0,.731-.489V7.07a.532.532,0,0,0-.331-.5ZM3.063,14.819V7.44c.112-.04.227-.085.334-.117.073-.023.141-.036.211-.054.133-.036.266-.072.4-.1.08-.016.154-.024.231-.035.112-.017.222-.033.327-.041.077,0,.151-.008.226-.011h.282a1.814,1.814,0,0,1,.21.015c.069.007.169.019.25.032s.133.023.193.037.149.036.221.057.116.036.171.056.133.05.2.078.1.045.151.069.118.064.175.1l.133.077c.045.027.108.074.159.113s.072.052.1.077c.056.047.106.093.157.133l.068.06a2.525,2.525,0,0,1,.186.2c.017.02.031.039.047.058.037.044.074.089.1.133s.033.047.05.07.049.069.07.1l.037.062c.019.028.036.058.05.082l.025.047.02.039v6.837A4.672,4.672,0,0,0,3.063,14.819Zm10.631,0a4.659,4.659,0,0,0-4.784.8V8.782c.234-.457,1.5-2.525,4.784-1.352Z"
              transform="translate(0 77.168)"
            ></path>
          </g>
        </svg>
      );
    if (select === "facebook")
      return (
        <svg id="icon_facebook" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
          <g id="Ellipse_60" data-name="Ellipse 60" fill="none" stroke="#ffd400" strokeWidth="1">
            <circle cx="12.5" cy="12.5" r="12.5" stroke="none"></circle>
            <circle cx="12.5" cy="12.5" r="12" fill="none"></circle>
          </g>
          <path
            id="Tracé_191"
            data-name="Tracé 191"
            d="M200.25,131.655h-1.833v-1.337c0-.41.424-.505.622-.505h1.184v-1.8L198.867,128a2.079,2.079,0,0,0-2.274,2.209v1.446H195.25v1.86h1.343v5.021h1.824v-5.021h1.55Z"
            transform="translate(-185.25 -121)"
            fill="#ffd400"
          ></path>
        </svg>
      );
    if (select === "agence")
      return (
        <svg id="icon_contact" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
          <g id="Ellipse_61" data-name="Ellipse 61" fill="none" stroke="#ffd400" strokeWidth="1">
            <circle cx="12.5" cy="12.5" r="12.5" stroke="none"></circle>
            <circle cx="12.5" cy="12.5" r="12" fill="none"></circle>
          </g>
          <g id="noun_Mail_675863" transform="translate(-13 -48.575)">
            <g id="Groupe_554" data-name="Groupe 554" transform="translate(20 57.575)">
              <path
                id="Tracé_189"
                data-name="Tracé 189"
                d="M20.733,983.362A.732.732,0,0,0,20,984.1v5.5a.732.732,0,0,0,.733.734h9.533A.732.732,0,0,0,31,989.6v-5.5a.732.732,0,0,0-.733-.733Zm1.083.9a.558.558,0,0,1,.4.161l3.077,2.9a.491.491,0,0,0,.418,0l3.082-2.9a.551.551,0,1,1,.756.8l-1.667,1.564,1.679,1.679a.55.55,0,1,1-.779.773l-1.7-1.7-.619.584a1.389,1.389,0,0,1-1.925,0l-.613-.579-1.7,1.7a.55.55,0,1,1-.779-.773l1.679-1.679-1.667-1.57a.551.551,0,0,1,.361-.957Z"
                transform="translate(-20 -983.362)"
                fill="#ffd400"
              ></path>
            </g>
          </g>
        </svg>
      );
    if (select === "contact")
      return (
        <svg id="icon_contact" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
          <g id="Ellipse_61" data-name="Ellipse 61" fill="none" stroke="#ffd400" strokeWidth="1">
            <circle cx="12.5" cy="12.5" r="12.5" stroke="none"></circle>
            <circle cx="12.5" cy="12.5" r="12" fill="none"></circle>
          </g>
          <g id="noun_Mail_675863" transform="translate(-13 -48.575)">
            <g id="Groupe_554" data-name="Groupe 554" transform="translate(20 57.575)">
              <path
                id="Tracé_189"
                data-name="Tracé 189"
                d="M20.733,983.362A.732.732,0,0,0,20,984.1v5.5a.732.732,0,0,0,.733.734h9.533A.732.732,0,0,0,31,989.6v-5.5a.732.732,0,0,0-.733-.733Zm1.083.9a.558.558,0,0,1,.4.161l3.077,2.9a.491.491,0,0,0,.418,0l3.082-2.9a.551.551,0,1,1,.756.8l-1.667,1.564,1.679,1.679a.55.55,0,1,1-.779.773l-1.7-1.7-.619.584a1.389,1.389,0,0,1-1.925,0l-.613-.579-1.7,1.7a.55.55,0,1,1-.779-.773l1.679-1.679-1.667-1.57a.551.551,0,0,1,.361-.957Z"
                transform="translate(-20 -983.362)"
                fill="#ffd400"
              ></path>
            </g>
          </g>
        </svg>
      );
    if (select === "devis")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16.866" height="21.75" viewBox="0 0 16.866 21.75">
          <path
            d="M13.483,18a1.483,1.483,0,1,0,1.483,1.483A1.483,1.483,0,0,0,13.483,18Zm0,1.977a.494.494,0,1,1,.494-.494A.494.494,0,0,1,13.483,19.977Z"
            transform="translate(-9.528 -10.091)"
          ></path>
          <path
            d="M13.483,26a1.483,1.483,0,1,0,1.483,1.483A1.483,1.483,0,0,0,13.483,26Zm0,1.977a.494.494,0,1,1,.494-.494A.494.494,0,0,1,13.483,27.977Z"
            transform="translate(-9.528 -14.136)"
          ></path>
          <path
            d="M13.483,34a1.483,1.483,0,1,0,1.483,1.483A1.483,1.483,0,0,0,13.483,34Zm0,1.977a.494.494,0,1,1,.494-.494A.494.494,0,0,1,13.483,35.977Z"
            transform="translate(-9.528 -18.182)"
          ></path>
          <path
            d="M17.44,2H9.531A2.536,2.536,0,0,0,7,4.531V21.219A2.536,2.536,0,0,0,9.531,23.75h11.8a2.536,2.536,0,0,0,2.531-2.531V8.426A6.426,6.426,0,0,0,17.44,2Zm5.438,5.932h-3.52a1.483,1.483,0,0,1-1.483-1.483V2.989a5.438,5.438,0,0,1,4.978,4.943Zm-1.542,14.83H9.531a1.542,1.542,0,0,1-1.542-1.542V4.531A1.542,1.542,0,0,1,9.531,2.989h7.355v3.46A2.472,2.472,0,0,0,19.358,8.92h3.52v12.3A1.542,1.542,0,0,1,21.335,22.761Z"
            transform="translate(-7 -2)"
          ></path>
          <path
            d="M27.932,20H22.494a.494.494,0,1,0,0,.989h5.438a.494.494,0,0,0,0-.989Z"
            transform="translate(-14.585 -11.102)"
          ></path>
          <path
            d="M27.932,28H22.494a.494.494,0,1,0,0,.989h5.438a.494.494,0,0,0,0-.989Z"
            transform="translate(-14.585 -15.148)"
          ></path>
          <path
            d="M27.932,36H22.494a.494.494,0,0,0,0,.989h5.438a.494.494,0,0,0,0-.989Z"
            transform="translate(-14.585 -19.193)"
          ></path>
        </svg>
      );
    if (select === "arrow_left")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="10.547" viewBox="0 0 15 10.547">
          <path
            className="aa"
            fill="#ffd400"
            d="M10.1,10.389a.532.532,0,1,1-.756-.748l3.833-3.833H.529A.527.527,0,0,1,0,5.277a.532.532,0,0,1,.529-.537H13.178L9.345.915a.543.543,0,0,1,0-.756.53.53,0,0,1,.756,0L14.841,4.9a.521.521,0,0,1,0,.748Z"
          ></path>
        </svg>
      );
    if (select === "fiche")
      return (
        <svg className="icon_fiche" xmlns="http://www.w3.org/2000/svg" width="13" height="15" viewBox="0 0 13 15">
          <g className="Rectangle_602" data-name="Rectangle 602" fill="none" stroke="#262626" strokeWidth="1">
            <rect width="13" height="15" stroke="none"></rect>
            <rect x="0.5" y="0.5" width="12" height="14" fill="none"></rect>
          </g>
          <path
            className="Union_1"
            data-name="Union 1"
            d="M-12744.5-1015v-1h4v1Zm0-2v-1h7v1Zm0-2v-1h7v1Z"
            transform="translate(12747.5 1025)"
            fill="#262626"
          ></path>
        </svg>
      );
    else return <>error</>;
  } else return <>error</>;
};

export default SVG;
